<div class="chat-block" *ngIf="auditLogs.length && showContent" @fadeIn>
  <div class="title-block">
    <div class="title">
      <div class="icon">
        <img src="assets/images/audit-log-black-icon.svg" alt="icon" />
      </div>
      <div class="text">Audit Log</div>
    </div>
    <div class="close">
      <img tooltip="Close" (click)="closeAuditLog()" src="assets/images/chat-history-close.svg" alt="icon" />
    </div>
  </div>
  <div class="conversation-block" appDynamicHeight="audit-log">
    <div class="audit-table-container">
      <p-table [value]="auditLogsGroupedByIssueID" [dataKey]="'issue_id'" [expandedRowKeys]="expandedRows"
        (onRowExpand)="onRowExpand($event)" (onRowCollapse)="onRowCollapse($event)" styleClass="main-audit-table">
        <ng-template #header>
          <tr>
            <th style="width: 5rem"></th>
            <th class="no-wrap-header">Issue No.</th>
            <th class="no-wrap-header">Issue Name</th>
            <th>Issue Description</th>
          </tr>
        </ng-template>
        <ng-template #body let-group let-expanded="expanded" let-rowIndex="rowIndex">
          <tr>
            <td>
              <p-button styleClass="row-toggler-button" [pRowToggler]="group"
                [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'" />
            </td>
            <!-- <td>{{ rowIndex + 1 }}</td>
              <td>{{ group.issueName }}</td>
              <td>{{ group.issueDescription }}</td> -->

            <td>{{ group.issue_id }}</td>
            <td>{{ group.issue_name }}</td>
            <td>{{ group.issue_description }}</td>

          </tr>
        </ng-template>
        <ng-template #expandedrow let-group>
          <tr>
            <td colspan="4">
              <p-table [value]="group.audits" styleClass="nested-audit-table" [sortField]="'UpdatedDate'"
                [sortOrder]="-1">
                <ng-template #header>
          <tr>
            <!-- <th>Survey Type</th>
            <th>Survey Date</th> -->
            <th>Field Name</th>
            <th>Previous Value</th>
            <th>Updated Value</th>
            <th pSortableColumn="UpdatedDate">Updated Date</th>
            <th>Updated By</th>
          </tr>
        </ng-template>
        <ng-template #body let-audit>
          <tr>
            <!-- <td>{{ audit.SurveyType }}</td>
            <td>{{ audit.SurveyDate }}</td>
            <td>{{ audit.FieldName }}</td>
            <td>{{ formatNumbersInString(audit.PreviousValue || "N/A") }}</td>
            <td>{{ formatNumbersInString(audit.UpdatedValue || "N/A") }}</td>
            <td>{{ audit.UpdatedDate }}</td>
            <td>{{ audit.UpdatedBy }}</td> -->
            <!-- <td>{{ '' }}</td>
            <td>{{ audit.survey_date }}</td> -->
            <td>{{ audit.field_name }}</td>
            <td>{{ formatNumbersInString(resolveDisplayValue(audit.field_name, audit.previous_value)) }}</td>
            <td>{{ formatNumbersInString(resolveDisplayValue(audit.field_name, audit.updated_value)) }}</td>
            <td>{{ formatAuditDate(audit.updated_date) }}</td>
            <td>{{ audit.updated_by }}</td>
          </tr>
        </ng-template>
      </p-table>
      </td>
      </tr>
      </ng-template>
      </p-table>
    </div>
  </div>
</div>